export default {"src":"/_next/static/media/empty_state_bookmarks.0af71ba7.svg","height":165,"width":170,"blurWidth":0,"blurHeight":0};